var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.061,
    height: 39.061,
    viewBox: "0 0 39.061 39.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.156,166.566h0a19.03,19.03,0,0,1-19.03-19.03h0a19.03,19.03,0,0,1,19.03-19.031h0a19.03,19.03,0,0,1,19.031,19.031h0A19.03,19.03,0,0,1,221.156,166.566Z",
    transform: "translate(-202.126 -128.505)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-202.126 -128.505)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M221.156,138.981c2.786,0,3.116.011,4.217.061a5.781,5.781,0,0,1,1.937.36,3.449,3.449,0,0,1,1.98,1.98,5.781,5.781,0,0,1,.36,1.937c.05,1.1.061,1.431.061,4.217s-.011,3.116-.061,4.216a5.782,5.782,0,0,1-.36,1.938,3.449,3.449,0,0,1-1.98,1.98,5.762,5.762,0,0,1-1.937.359c-1.1.05-1.43.061-4.217.061s-3.116-.011-4.216-.061A5.769,5.769,0,0,1,215,155.67a3.456,3.456,0,0,1-1.98-1.98,5.763,5.763,0,0,1-.359-1.938c-.05-1.1-.061-1.43-.061-4.216s.011-3.116.061-4.217a5.762,5.762,0,0,1,.359-1.937A3.456,3.456,0,0,1,215,139.4a5.789,5.789,0,0,1,1.938-.36c1.1-.05,1.43-.061,4.216-.061m0-1.88c-2.834,0-3.189.013-4.3.063a7.672,7.672,0,0,0-2.533.485,5.336,5.336,0,0,0-3.051,3.052,7.64,7.64,0,0,0-.485,2.533c-.051,1.113-.063,1.468-.063,4.3s.012,3.189.063,4.3a7.64,7.64,0,0,0,.485,2.533,5.336,5.336,0,0,0,3.051,3.052,7.7,7.7,0,0,0,2.533.485c1.113.05,1.468.062,4.3.062s3.189-.012,4.3-.062a7.692,7.692,0,0,0,2.533-.485,5.341,5.341,0,0,0,3.052-3.052,7.666,7.666,0,0,0,.485-2.533c.051-1.113.063-1.468.063-4.3s-.012-3.189-.063-4.3a7.666,7.666,0,0,0-.485-2.533,5.341,5.341,0,0,0-3.052-3.052,7.666,7.666,0,0,0-2.533-.485c-1.113-.05-1.468-.063-4.3-.063"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M221.156,142.178a5.358,5.358,0,1,0,5.358,5.358,5.358,5.358,0,0,0-5.358-5.358m0,8.836a3.478,3.478,0,1,1,3.478-3.478,3.478,3.478,0,0,1-3.478,3.478"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.978,141.966a1.252,1.252,0,1,1-1.252-1.252,1.252,1.252,0,0,1,1.252,1.252"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.da4705e36474b709455940e45f0301e0.svg";
export { ForwardRef as ReactComponent };